export async function pushProfilePhotoToS3(presignedUrl, uploadPhoto) {
    const myHeaders = new Headers({ 'Content-Type': uploadPhoto.type.includes('svg') ? uploadPhoto.type : 'image/*' });
    const response = await fetch(presignedUrl, {
        method: 'PUT',
        headers: myHeaders,
        body: uploadPhoto});
    return response;
}